import { defineMessages } from 'react-intl';

export default defineMessages({
  chooseSherpa: {
    id: 'search.header.stepper.chooseSherpa',
    defaultMessage:
      'Choisissez votre Sherpa parmi les professeurs certifiés par notre équipe',
  },
  planTrial: {
    id: 'search.header.stepper.planTrial',
    defaultMessage:
      "Planifiez votre cours d'essai en ligne et bénéficiez d'un accompagnement personnalisé",
  },
  exchangeWithTeam: {
    id: 'search.header.stepper.exchangeWithTeam',
    defaultMessage:
      'Échangez avec notre équipe pédagogique pour trouver la formule de suivi qui vous convient',
  },
});
